module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.query.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.query.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.query.total * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4299c805!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/pagination/pagination.vue
// module id = 1469
// module chunks = 1